import styled from 'styled-components';
import { COLORS, DEVICES } from '@/theme';

export const StyledPageWrapper = styled.div`
  background: ${COLORS.WHITE};
  min-height: 100vh;
  display: flex;
`;

export const StyledFormSection = styled.div`
  background: ${COLORS.WHITE};
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledFormWrapper = styled.div`
  background: ${COLORS.WHITE};
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media screen and ${DEVICES.LAPTOP_S} {
    max-width: 30rem;
    padding: 2rem;
  }
`;

export const StyledBanner = styled.div`
  flex: 1;
  background: url('/images/login_bg.jpg');
  background-size: cover;
  background-position: center;

  @media screen and ${DEVICES.LAPTOP_S} {
    height: 100vh;
    background-size: cover;
  }
`;
